module.exports = __webpack_public_path__ + "img/shape2.0ab4df72.png";